module.exports = __webpack_public_path__ + "img/diesel-option1.0e9d3ad2.jpg";